export default __webpack_public_path__ + "static/media/ContactLogo.8b7466c7.svg";